import helpers from '../../helpers';
import Storage from './../Storage/storage';

$(window).scroll(async (event) => {
    const elementSubscribeToast = '.hh-subscribe-toast';
    const elementTrigger = '.hh-actions-panel'; // элемент, при появлении которого произойдёт всплытие окна
    const localStorageName = 'subscribeToastShowTimestamp';
    const delayTime = 5000; // Время задержки
    const showDelay = 1000 * 60 * 60 * 24 * 10; // 10 дней — пауза между повторным срабатыванием у пользователя

    await new Promise((resolve, reject) => setTimeout(resolve, delayTime)); // ждём нужное время

    const storage = new Storage();

    // Если регион уже занят (например, другим всплывающим окном)
    if (storage.get(helpers.windowRegionsFilling().bottom)) {
        return;
    }

    // Попап подписки недавно всплывал
    if (storage.get(localStorageName)) {
        return;
    }

    // Ожидание, пока пользователь проскролит регион, после которого будет всплывание подписки
    await helpers.elementIsShow(elementTrigger, true);

    $(elementSubscribeToast).show(500);

    hh_send_counter_target('content.subscribeToast.show');

    storage.save(localStorageName, true, Date.now() + showDelay); // Сохраняем время срабатывания
    storage.save(helpers.windowRegionsFilling().bottom, true, Date.now() + delayTime); // Забиваем регион
});

$(document).ready(() => {
    $('.hh-subscribe-toast__close-button').click((event) => {
        const subscribeToast = $(event.target).parents('.hh-subscribe-toast');

        hh_send_counter_target('content.subscribeToast.clickClose');

        subscribeToast.hide(500);
    });

    $('.hh-subscribe-toast__form').find('form').submit(() => {
        hh_send_counter_target('content.subscribeToast.submit');
    });
});